/* A SNOW SHOWER OVER THE WHOLE SCREEN — on Home, once per sign-in (Max, 31/10: "Hiện mỗi lần đăng nhập nhé ở homepage thui").
   About six seconds, then it melts away and the screen is still. "Once per sign-in" is the account's own last sign-in time
   (UserLastLogin, sent with the sign-in check): the shower plays when that time is new to this browser. Only while the season is
   on with motion on (season.js); theme-christmas.css hides it for reduced motion. Over the page, under the header and every popup
   (z-index 990); clicks go through it.
   ~36 SMALL FLAKES, each moved on its own (transform + opacity only). The first version slid two tiled layers the size of the screen,
   and Home fell to 8 frames a second while they did (Max: "trang homepage bị lag", 31/10) — the screen is redrawn wherever a layer
   moves, and two full-screen layers are the whole screen twice; 36 flakes are a few hundred pixels each. */
import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { readSeason } from './season';

const KEY = 'portalXmasShowerLogin';

export default function XmasShower({ lastLogin }) {
  const [run, setRun] = useState(null);
  useEffect(() => {
    if (!lastLogin) return undefined;
    const s = readSeason();
    if (!s.on || !s.snow) return undefined;
    let shown = null;
    try { shown = localStorage.getItem(KEY); } catch (e) { shown = null; }
    if (shown === lastLogin) return undefined;
    try { localStorage.setItem(KEY, lastLogin); } catch (e) { /* private window */ }
    setRun(lastLogin);
    const h = setTimeout(() => setRun(null), 9800);   // it starts once the page has settled (data-season-ready), then ~6 s
    return () => clearTimeout(h);
  }, [lastLogin]);
  const flakes = useMemo(() => (run ? Array.from({ length: 36 }, (_, i) => ({
    '--x': `${((i + 0.15 + Math.random() * 0.7) * 100) / 36}%`,
    '--s': (0.6 + Math.random() * 0.8).toFixed(2),
    '--dx': `${Math.round((Math.random() - 0.5) * 120)}px`,
    '--r': `${Math.round((Math.random() - 0.5) * 240)}deg`,
    animationDuration: `${(4.6 + Math.random() * 1.8).toFixed(2)}s`,
    animationDelay: `${(Math.random() * 1.4).toFixed(2)}s`,
  })) : []), [run]);
  if (!run) return null;
  return ReactDOM.createPortal(
    <div className="xmas-shower" aria-hidden="true" data-xmas-shower>{flakes.map((st, i) => <i key={i} style={st} />)}</div>,
    document.body);
}

/* A LITTLE BURST OF SNOWFLAKES WHERE YOU CLICK (Max, 31/10: "hiệu ứng khi click chuột") — anywhere in the portal, in season,
   with motion on and no reduced-motion request. Eight flakes fly out and fade in 0.7 s; nothing is in the way of the click
   itself (pointer-events none, added after it). */
export function XmasClick() {
  useEffect(() => {
    const reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    const onDown = (e) => {
      if (e.button !== 0 || (reduce && reduce.matches)) return;
      const s = readSeason();
      if (!s.on || !s.snow) return;
      const b = document.createElement('span');
      b.className = 'xmas-burst';
      b.setAttribute('aria-hidden', 'true');
      b.style.left = `${e.clientX}px`; b.style.top = `${e.clientY}px`;
      for (let i = 0; i < 8; i += 1) {
        const f = document.createElement('i');
        const a = (Math.PI * 2 * i) / 8 + (Math.random() - 0.5) * 0.5;
        const d = 26 + Math.random() * 18;
        f.style.setProperty('--dx', `${Math.cos(a) * d}px`);
        f.style.setProperty('--dy', `${Math.sin(a) * d}px`);
        f.style.setProperty('--rot', `${Math.round(Math.random() * 180)}deg`);
        f.className = i % 3 === 0 ? 'b' : (i % 3 === 1 ? 's' : '');
        b.appendChild(f);
      }
      document.body.appendChild(b);
      setTimeout(() => b.remove(), 800);
    };
    window.addEventListener('pointerdown', onDown, { passive: true });
    return () => window.removeEventListener('pointerdown', onDown);
  }, []);
  return null;
}
